// ----------------------------------------------------------------------

/**
 * Preserves ordering context for checkout links (customer, location, brand).
 */
export function buildOrderingCheckoutQuery(searchParams) {
  const next = new URLSearchParams();
  const customerId = searchParams.get('customer_id');
  const locationId = searchParams.get('location_id');
  const brandId = searchParams.get('brand_id');
  if (customerId) {
    next.set('customer_id', customerId);
  }
  if (locationId) {
    next.set('location_id', locationId);
  }
  if (brandId) {
    next.set('brand_id', brandId);
  }
  const qs = next.toString();
  return qs ? `?${qs}` : '';
}
